

export class CellRendererName
{
    constructor(rendererName) {
        this.rendererName = rendererName;
    }

    get name() {
        return this.rendererName.endsWith('Renderer')
            ? this.rendererName
            : `${this.rendererName}Renderer`;
    }

    static from(value) {
        if (! value)
            return null;

        const name = value
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join('');

        return new CellRendererName(name);
    }
}